import {Component, OnInit} from '@angular/core';
import {ViewManagerService} from "../../../../services/view-manager.service";
import {SessionManagerService} from "../../../../services/session-manager.service";
import {AdminResultCaseService} from "../../case.service";
import {ActivatedRoute} from "@angular/router";
import {ResultCase} from "../../../../model/lookup-results.model";
import {ChannelDefinition} from "../../../../model/channels.model";
import {Session} from "../../../../model/session.model";

@Component({
  selector: 'admin-results-cases-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class AdminResultsCaseViewComponent implements OnInit {

  id!: string;
  session: Session;

  constructor(
    private route: ActivatedRoute,
    private viewManager: ViewManagerService,
    private sessionManager: SessionManagerService,
    private caseService: AdminResultCaseService,
  ) {
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('internal')!;
    this.session = this.sessionManager.session!;
    this.caseService.select(this.id);
  }

  get selected(): ResultCase {
    return this.caseService.selected;
  }

  get definition(): ChannelDefinition {
    return this.caseService.definition;
  }

  riskClass(risk: string) {
    if (risk == "high") {
      return "danger";
    } else if (risk == "medium") {
      return "warning";
    } else if (risk == "low") {
      return "success";
    }
    return "danger";
  }

  statusClass(status: string) {
    if (status == "NEW") {
      return "success";
    } else if (status == "OPEN") {
      return "warning";
    } else if (status == "CLOSED") {
      return "";
    } else if (status == "REPORTED") {
      return "danger";
    }
    return "danger";
  }

  get caseManagerUrl() {
    return this.session.cases + "/issue/" + this.caseService.selected.external;
  }
}
